/**
 * HRSidebarWidgets — HR-PORTAL-SPLIT (Jul 22, 2026).
 *
 * Compact HR Insights + Upcoming Events widgets rendered inside the
 * dark HR Portal sidebar (beneath the HR Dashboard nav item). The main
 * HR Dashboard focuses on KPIs + Quick Access navigation; these act as
 * always-visible supporting information. HR Portal roles only.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const HRSidebarWidgets = () => {
  const [insights, setInsights] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/api/hr/dashboard-insights`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) setInsights(res.data);
      } catch {
        // Silent — widgets simply don't render on failure
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!insights) return null;

  // HR-CLEANUP-001 (Jul 2026): HR Insights section removed per user request.
  const events = (insights.upcoming_events || []).slice(0, 4);

  return (
    <div className="px-3 pb-4 space-y-3" data-testid="hr-sidebar-widgets">
      {/* Upcoming Events */}
      <div className="bg-white/5 rounded-xl p-3" data-testid="sidebar-upcoming-events">
        <p className="text-[10px] font-bold uppercase tracking-wider text-white/40 mb-2">Upcoming Events</p>
        {events.length === 0 ? (
          <p className="text-xs text-white/40 px-2 py-1">No upcoming events</p>
        ) : (
          <div className="space-y-1.5">
            {events.map((ev, i) => (
              <div key={i} className="px-2 py-1.5 rounded-lg bg-white/5">
                <p className="text-xs font-medium text-white/85 leading-tight truncate">{ev.title}</p>
                <p className="text-[11px] text-white/45 mt-0.5 truncate">
                  {/* eslint-disable-next-line no-restricted-syntax -- DATE-DISPLAY-001: intentional compact sidebar event date */}
                  {ev.date ? new Date(ev.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : ''}
                  {ev.subtitle ? ` · ${ev.subtitle}` : ''}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HRSidebarWidgets;
